/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Stock_Qty_HeaderInputs */

const vi_product_stock_qty_header = /** @type {(inputs: Product_Stock_Qty_HeaderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng tồn`)
};

/**

* @param {Product_Stock_Qty_HeaderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_stock_qty_header = /** @type {((inputs?: Product_Stock_Qty_HeaderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Stock_Qty_HeaderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_stock_qty_header(inputs)
});